<template>
    <div>
        <div class="flex justify-center w-full">
            <custom-tooltip bottom border>
                <app-button icon circle @click="openNewFilter">
                    <img
                        src="@/assets/images/filter.svg"
                        height="15"
                        width="15"
                        alt="reload img"
                    />
                </app-button>
                <template #tooltip> Modificar filtros de búsqueda </template>
            </custom-tooltip>
        </div>

        <div class="flex flex-col items-center mt-2">
            <div
                v-if="activeFilters.includes('fullName')"
                class="md:w-7/12 w-8/12 mx-auto mt-2"
            >
                <custom-input
                    id="fullName"
                    v-model="fullName"
                    type="text"
                    name="fullNameSearch"
                    label="Nombre"
                    class="mr-2"
                    aria-label="fullName"
                    :error="
                        introFullName && !isValidFullName
                            ? 'Ingrese nombre valido'
                            : ''
                    "
                    @blur="onBlurFullName"
                    @enter="onEnter"
                    @click-icon="onEnter"
                >
                    <template #icon> 🧑 </template>
                </custom-input>
            </div>
            <div
                v-if="activeFilters.includes('phone')"
                class="md:w-7/12 w-8/12 mx-auto mt-2"
            >
                <custom-input
                    id="phone"
                    v-model="phone"
                    type="text"
                    name="phoneSearch"
                    label="Celular"
                    class="mr-2"
                    aria-label="phone"
                    :error="
                        introPhone && !isValidPhone
                            ? 'Ingrese número valido'
                            : ''
                    "
                    @blur="onBlurPhone"
                    @input="clearPhone"
                    @enter="onEnter"
                    @click-icon="onEnter"
                >
                    <template #icon> 📱 </template>
                </custom-input>
            </div>

            <div
                v-if="activeFilters.includes('email')"
                class="md:w-7/12 w-8/12 mx-auto mt-2"
            >
                <custom-input
                    id="email"
                    v-model="email"
                    type="text"
                    name="emailSearch"
                    label="Correo"
                    class="mr-2"
                    aria-label="Email"
                    :error="
                        introEmail && !isValidEmail
                            ? 'Ingrese correo valido'
                            : ''
                    "
                    @blur="onBlurEmail"
                    @input="lowerCaseEmail"
                    @enter="onEnter"
                    @click-icon="onEnter"
                >
                    <template #icon> ✉ </template>
                </custom-input>
            </div>

            <div
                v-if="activeFilters.includes('identificationNumber')"
                class="md:w-7/12 w-8/12 mx-auto mt-2"
            >
                <custom-input
                    id="document"
                    v-model="identificationNumber"
                    type="text"
                    name="document"
                    label="Número de documento"
                    class="md:w-6/12 w-8/12 mx-auto mt-3"
                    aria-label="Document"
                    :error="
                        introIdentificationNumber &&
                        !isValidIdentificationNumber
                            ? 'Ingrese documento Valido'
                            : ''
                    "
                    @blur="onBlurIdentificationNumber"
                    @enter="onEnter"
                    @click-icon="onEnter"
                >
                    <template #icon> 🖋 </template>
                </custom-input>
            </div>
        </div>

        <app-dialog v-model="isOpenModal" size="lg" @close="pushNewFilter">
            <template #header>
                <div class="flex items-center justify-between gap-4">
                    <h3 class="text-base font-semibold text-theme-base">
                        Selecciona los filtros
                    </h3>

                    <app-button
                        :disabled="!filters.length"
                        @click="isOpenModal = false"
                    >
                        ✔️ Aplicar filtros ({{ filters.length }})
                    </app-button>
                </div>
            </template>
            <cards-selector v-model="filters" :base="$data.$baseFilters" />
        </app-dialog>
    </div>
</template>

<script>
import { customersFilters } from "@/common/fields/filters-query";
import {
    emailSimpleRegex,
    nameRegex,
    stringNumberRegex
} from "@/common/lib/regex";

import AppDialog from "@/components/utils/AppDialog.vue";
import CardsSelector from "@/components/utils/CardsSelector.vue";
import CustomInput from "@/components/utils/CustomInput.vue";

export default {
    name: "CustomersFilters",
    components: {
        AppDialog,
        CardsSelector,
        CustomInput
    },
    model: {
        prop: "itemsCurrent",
        event: "change"
    },
    props: {
        itemsCurrent: {
            default: () => ({}),
            type: Object,
            require: true
        },
        enabledFilters: {
            default: () => ["email", "identificationNumber"],
            type: Array,
            require: true
        }
    },
    data: () => ({
        activeFilters: [""],
        isOpenModal: false,
        email: "",
        phone: "",
        fullName: "",
        identificationNumber: "",
        introEmail: false,
        introPhone: false,
        introFullName: false,
        introLastName: false,
        introFirstName: false,
        introIdentificationNumber: false,
        filters: [""],
        $baseFilters: customersFilters
    }),
    computed: {
        isValidEmail() {
            return emailSimpleRegex.test(this.email);
        },
        isValidIdentificationNumber() {
            return stringNumberRegex.test(this.identificationNumber);
        },
        isValidPhone() {
            return stringNumberRegex.test(this.phone);
        },
        isValidFullName() {
            return nameRegex.test(this.fullName);
        }
    },
    watch: {
        filters() {
            this.applyFilter();
        },
        enabledFilters(value) {
            this.setEnabledFilters(value);
        }
    },
    mounted() {
        this.setEnabledFilters(this.enabledFilters);
        this.setInput(this.itemsCurrent);
    },
    methods: {
        setInput(value) {
            const filters = Object.keys(value);
            this.activeFilters = filters;
            this.filters = filters;
            if ("email" in value) this.email = value.email;
            if ("phone" in value) this.phone = value.phone;
            if ("fullName" in value) this.fullName = value.fullName;
            if ("identificationNumber" in value) {
                this.identificationNumber = value.identificationNumber;
            }
        },
        openNewFilter() {
            this.isOpenModal = true;
        },
        pushNewFilter() {
            this.activeFilters = [...this.filters];
            this.applyFilter();
        },
        applyFilter() {
            this.$emit("change", {
                ...{
                    ...(this.activeFilters.includes("email") && this.email
                        ? { email: this.email }
                        : null)
                },
                ...{
                    ...(this.activeFilters.includes("phone") && this.phone
                        ? { phone: this.phone }
                        : null)
                },
                ...{
                    ...(this.activeFilters.includes("identificationNumber") &&
                    this.identificationNumber
                        ? { identificationNumber: this.identificationNumber }
                        : null)
                },
                ...{
                    ...(this.activeFilters.includes("fullName") && this.fullName
                        ? { fullName: this.fullName }
                        : null)
                }
            });
        },
        onEnter() {
            this.applyFilter();
            this.$emit("enter");
        },
        onBlurFullName() {
            this.introFullName = true;
            this.applyFilter();
        },
        onBlurPhone() {
            this.introPhone = true;
            this.applyFilter();
        },
        onBlurEmail() {
            this.introEmail = true;
            this.applyFilter();
        },
        onBlurIdentificationNumber() {
            this.introIdentificationNumber = true;
            this.applyFilter();
        },
        clearPhone() {
            this.phone = this.phone.trim().replace(/\s+/g, "");
        },
        lowerCaseEmail() {
            this.email = this.email.trim().replace(/\s+/g, "").toLowerCase();
        },
        setEnabledFilters(value) {
            this.baseFilters = customersFilters.filter((item) => {
                const hasPermission =
                    !item.permissions ||
                    item.permissions.every((permission) =>
                        this.$ability.hasPermission(permission)
                    );
                return value.includes(item.id) && hasPermission;
            });
        }
    }
};
</script>
